import { render } from "./QuestionsQuiz.vue?vue&type=template&id=db9b3262&translate=no"
import script from "./QuestionsQuiz.vue?vue&type=script&lang=js"
export * from "./QuestionsQuiz.vue?vue&type=script&lang=js"

import "./QuestionsQuiz.vue?vue&type=style&index=0&id=db9b3262&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__